import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { ArticleManageService } from '../../../../../../services/article-manage.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Editor, Toolbar } from 'ngx-editor';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Decoration, DecorationSet} from 'prosemirror-view';
import { EditorState, Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { isNodeActive } from 'ngx-editor/helpers';
import { setBlockType } from 'prosemirror-commands';
import { HWResourceService as ResourceService, HWResourceService } from '../../../../../../services/huawei-resource.service';


@Component({
    selector: 'app-article-manager-articles',
    templateUrl: './article-manager-articles.component.html',
    styleUrls: ['./article-manager-articles.component.scss'],
    standalone: false
})
export class ArticleManagerArticlesComponent implements OnInit, OnDestroy {
  loading = false;
  isImageUploading = false;
  articles: any[] = [];
  total = 0;
  pageSize = 10;
  pageIndex = 1;
  imageUploadProgress = 0;
  // Filters
  searchKeyword = '';
  selectedSyllabusId: number | null = null;
  syllabusList: any[] = [];

  // Editor related
  editor!: Editor;
  placeholderPlugin!: Plugin;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear'],
  ];
  // colorPresets = ['red', '#FF0000', 'rgb(255, 0, 0)'];
  // Form related
  drawerVisible = false;
  drawerTitle = '发布文章';
  editId: number | null = null;

  articleForm: FormGroup;

  // Tags selection
  availableTags: any[] = [];

  constructor(
    private articleSvc: ArticleManageService,
    private message: NzMessageService,
    private modal: NzModalService,
    private resService: ResourceService,
    private cdr: ChangeDetectorRef
  ) {
    this.articleForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      syllabusId: new FormControl(0),
      summary: new FormControl(''),
      content: new FormControl('', [Validators.required]),
      cover: new FormControl(''),
      status: new FormControl(1),
      tagIds: new FormControl([]),
      newTagNames: new FormControl([])
    });
  }

  ngOnInit(): void {

    this.placeholderPlugin = new Plugin({
      // key: new PluginKey(`custom-menu-image-upload`),
      // @ts-ignore
      // view: () => {
      //   return {
      //     update: this.editor.update,
      //   };
      // },
      state: {
        init() { return DecorationSet.empty; },
        apply(tr, set) {
          console.log(tr);
          // Adjust decoration positions to changes made by the transaction
          set = set.map(tr.mapping, tr.doc);
          // See if the transaction adds or removes any placeholders
          // @ts-ignore
          let action = tr.getMeta(this);
          if (action && action.add) {
            let widget = document.createElement("placeholder")
            widget.className = 'ngx-editor-image-placeholder';
            let deco = Decoration.widget(action.add.pos, widget, {id: action.add.id})
            set = set.add(tr.doc, [deco]);
          } else if (action && action.remove) {
            // @ts-ignore
            set = set.remove(set.find(null, null,
              spec => spec.id == action.remove.id))
          }
          return set
        }
      },
      props: {
        decorations(state) { return this.getState(state) }
      }
    });
    this.editor = new Editor({
      // @ts-ignore
      // plugins: [this.placeholderPlugin]
    });
    // @ts-ignore
    // this.editor.registerPlugin(this.placeholderPlugin);
    this.loadSyllabus();
    this.loadTags();
    this.loadArticles();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  loadSyllabus(): void {
    this.articleSvc.getSyllabus().then(res => {
      this.syllabusList = this.extractListData(res);
    });
  }

  loadTags(): void {
    this.articleSvc.getTags().then(res => {
      this.availableTags = this.extractListData(res);
    });
  }

  private extractListData(res: any): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }

    // Common response structures
    if (Array.isArray(res.data)) {
      return res.data;
    }
    if (Array.isArray(res.rows)) {
      return res.rows;
    }
    if (Array.isArray(res.list)) {
      return res.list;
    }

    // Nested structures like { data: { list: [] } } or { data: { rows: [] } }
    if (res.data) {
      if (Array.isArray(res.data.list)) {
        return res.data.list;
      }
      if (Array.isArray(res.data.rows)) {
        return res.data.rows;
      }
    }

    return [];
  }

  loadArticles(): void {
    this.loading = true;
    const params = {
      page: this.pageIndex,
      limit: this.pageSize,
      keyword: this.searchKeyword,
    };
    if (this.selectedSyllabusId) {
      // @ts-ignore
      params.syllabusId = this.selectedSyllabusId || 0
    }
    this.articleSvc.getArticles(params).then(res => {
      this.loading = false;
      // Handle both { list, total } and { data: { list, total } }
      const data = res.data || res;
      this.articles = data.list || [];
      this.total = data.total || 0;
    }).catch(() => {
      this.loading = false;
      this.message.error('加载文章列表失败');
    });
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.loadArticles();
  }

  openAdd(): void {
    this.drawerTitle = '发布文章';
    this.editId = null;
    this.articleForm.reset({
      status: 1,
      syllabusId: 0,
      content: '',
      tagIds: [],
      newTagNames: []
    });
    this.drawerVisible = true;
  }

  openEdit(id: number): void {
    this.drawerTitle = '编辑文章';
    this.editId = id;
    this.loading = true;
    this.articleSvc.getArticleDetail(id).then(res => {
      this.loading = false;
      const article = res;
      this.articleForm.patchValue({
        title: article.title,
        syllabusId: article.syllabusId || 0,
        summary: article.summary,
        content: article.content,
        cover: article.cover,
        status: article.status,
        tagIds: article.tags ? article.tags.map((t: any) => t.id) : [],
        newTagNames: []
      });
      this.drawerVisible = true;
    }).catch(() => {
      this.loading = false;
      this.message.error('获取文章详情失败');
    });
  }

  closeDrawer(): void {
    this.drawerVisible = false;
  }

  onCoverUploaded(event: any): void {
    if (event && event.url) {
      this.articleForm.patchValue({ cover: event.url });
    }
  }

  saveArticle(): void {
    if (this.articleForm.invalid) {
      this.message.warning('请填写必填项');
      return;
    }

    const data = this.articleForm.value;

    const saveAction = this.editId
      ? this.articleSvc.updateArticle(this.editId, data)
      : this.articleSvc.createArticle(data);

    const t1 = Date.now();
    this.loading = true;
    saveAction.then((resp) => {
      console.log(resp);
      const now = Date.now();
      const delta = 1000 - (now - t1);
      setTimeout(() => {
        this.message.success(this.editId ? '更新成功' : '发布成功');
        this.drawerVisible = false;
        if (!this.editId) {
          this.pageIndex = 1;
        }
        this.loadArticles();
      }, delta);
    }).catch((err) => {
      this.message.error(err.message || '操作失败');
      this.loading = false;
    });
  }

  deleteArticle(id: number): void {
    this.modal.confirm({
      nzTitle: '确认删除该文章吗？',
      nzContent: '删除后将进入回收站。',
      nzOkText: '确认',
      nzOkDanger: true,
      nzOnOk: () => {
        this.loading = true;
        const t1 = Date.now();
        this.articleSvc.deleteArticle(id).then(() => {
          const now = Date.now();
          const delta = 1000 - (now - t1);
          setTimeout(() => {
            this.loading = false;
            this.message.success('删除成功');
            this.loadArticles();
          }, delta)
        }).catch(err => {
          this.message.error(err.message || '删除失败');
        });


      }
    });
  }

  getStatusText(status: number): string {
    switch (status) {
      case 0: return '草稿';
      case 1: return '已发布';
      case -1: return '已删除';
      default: return '未知';
    }
  }

  getStatusColor(status: number): string {
    switch (status) {
      case 0: return 'orange';
      case 1: return 'green';
      case -1: return 'red';
      default: return 'default';
    }
  }


  ///////////////////////////////////////////////////

  findPlaceholder(state: EditorState, id: any): number | null {
    // @ts-ignore
    let decos = this.placeholderPlugin.getState(state);
    if (!decos) return null;
    // @ts-ignore
    let found = decos.find(null, null, spec => spec.id == id);
    return found.length ? found[0].from : null;
  }
  doImageProgress = (p: number) => {
    if (p > 1) {
      p = 1;
    }
    if (p < 0) {
      p = 0;
    }
    // console.log(Math.floor(p * 100));
    // @ts-ignore
    this.imageUploadProgress =  Math.floor(p * 100);
  }
  doImageUploadSuccess = (name: string, hash: string, url: string, file?: File, inOss = false) => {
    console.log('doImageUploadSuccess', name, hash, url, file);
    const tr = this.editor.view.state.tr;
    if (!tr.selection.empty) {
      tr.deleteSelection();
    }
    // @ts-ignore
    // tr.setMeta(this.placeholderPlugin, {add: {id, pos: tr.selection.from}});
    const pos =  tr.selection.from;
    // If the content around the placeholder has been deleted, drop
    // the image
    if (pos == null) {
      return;
    }
    // Otherwise, insert it at the placeholder's position, and remove
    // the placeholder
    this.editor.view.dispatch(this.editor.view.state.tr
      // @ts-ignore
      .replaceWith(pos, pos, this.editor.schema.nodes.image.create({src: url})));
      // .setMeta(this.placeholderPlugin, {remove: {id}}));
    this.isImageUploading = false;
  }
  doImageUploadFailure = (err: any) => {
    console.log('doImageUploadFailure', err);
    this.isImageUploading = false;
  }
  startImageUpload(file: File) {
    // // A fresh object to act as the ID for this upload
    // const id = {}
    // // Replace the selection with a placeholder
    // let tr = this.editor.view.state.tr;
    // if (!tr.selection.empty) {
    //   tr.deleteSelection()
    // }
    // // @ts-ignore
    // tr.setMeta(this.placeholderPlugin, {add: {id, pos: tr.selection.from}});
    // this.editor.view.dispatch(tr);
    this.isImageUploading = true;
    this.resService.doUpload({file, /* type: ResType,*/
      osspath: 'cms/',
      progress_cb: this.doImageProgress,
      // @ts-ignore
      success_cb: this.doImageUploadSuccess,
      error_cb: this.doImageUploadFailure});

    // this.uploadFile(file).then(url => {
    //   let pos = this.findPlaceholder(view.state, id)
    //   // If the content around the placeholder has been deleted, drop
    //   // the image
    //   if (pos == null) return
    //   // Otherwise, insert it at the placeholder's position, and remove
    //   // the placeholder
    //   view.dispatch(view.state.tr
    //     // @ts-ignore
    //     .replaceWith(pos, pos, this.editor.schema.nodes['image'].create({src: url}))
    //     // @ts-ignore
    //     .setMeta(this.placeholderPlugin, {remove: {id}}))
    // }).catch(() => {
    //   // On failure, just clean up the placeholder
    //   let pos = this.findPlaceholder(view.state, id)
    //   if (pos != null) {
    //     // @ts-ignore
    //     view.dispatch(view.state.tr.setMeta(this.placeholderPlugin, {remove: {id}}))
    //   }
    // });
  }
  //
  // uploadFile(file: File): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.hwSvc.asyncDoUpload({
  //       file: file as any,
  //       osspath: 'article/images',
  //       success_cb: (res: any) => {
  //         resolve(res.url);
  //       },
  //       error_cb: (err: any) => {
  //         this.message.error('图片上传失败');
  //         reject(err);
  //       }
  //     });
  //   });
  // }
  //
  onImageSelected(event: any): void {
    const file = event.target?.files?.[0];
    if (file && this.editor.view.state.selection.$from.parent.inlineContent) {
      // @ts-ignore
      this.startImageUpload( file);
    }
    this.editor.view.focus();
    // Reset the input so the same file can be selected again
    event.target.value = '';
  }

}
